import React, { useEffect } from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";

import { WizardMainWrapper } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardMainWrapper";
import { FeatureUnavailable } from "components/FeatureUnavailable";

import { useAppBaseContext, useUrqlContext } from "providers";
import { useWizardActions } from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { useCheckIsWizardEnabled } from "hooks/wizardHooks/useEnabledWizardObjs";

const Wizard = Scrivito.connect(() => {
  const { projectId, nodeId, subType, step } = Scrivito.currentPageParams();
  const { lang } = useAppBaseContext();
  const { client } = useUrqlContext();
  const { getWizardData, setInitialState, resetState } = useWizardActions();

  useEffect(() => {
    setInitialState({
      urqlClient: client,
      language: lang,
      projectId,
      nodeId,
      subType,
      step: isNaN(Number(step)) ? null : Number(step),
    });

    if (nodeId && step !== 0) {
      getWizardData();
    }
    return () => {
      resetState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <WizardMainWrapper />;
});

const CheckedPage = (props) => {
  const { subType } = Scrivito.currentPageParams();
  const checkIsWizardEnabled = useCheckIsWizardEnabled();
  const isPageEnabled = checkIsWizardEnabled(subType);
  if (!isPageEnabled) {
    return <FeatureUnavailable />;
  }
  return (
    <ObjValidator {...props}>
      <Wizard {...props} />
    </ObjValidator>
  );
};
export default CheckedPage;
Scrivito.provideComponent("Wizard", CheckedPage);
